import { render } from "./ui-sidebar-modules.vue?vue&type=template&id=69988484&scoped=true"
import script from "./ui-sidebar-modules.vue?vue&type=script&lang=js"
export * from "./ui-sidebar-modules.vue?vue&type=script&lang=js"

import "./ui-sidebar-modules.vue?vue&type=style&index=0&id=69988484&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69988484"]])

export default __exports__